<script>
import { mapState } from 'vuex';
import { filter, get, orderBy } from 'lodash';

import base from '@/views/config/addon-cards/templates/base.vue';
import commonMixin from '@/plans/ZOOM_ROOMS/mixin';
import { planTypes } from '@/common/constants';
import { ZOOM_MEETING_SUB_TYPES } from '@/plans/ZOOM_MEETING/common/utils';

export default {
  mixins: [base, commonMixin],
  for: ()=> {
    if (window?.$config('plan') === ZOOM_MEETING_SUB_TYPES.ZONE_EDU_SCH_CMP) {
      return true;
    }
    return planTypes.map([planTypes.ZONE_EDU_PLUS, planTypes.VISITOR_MANAGEMENT, planTypes.WORKSPACE_RESERVATION]);
  },
  created() {
    const { amount } = this.lowestPlan;
    this.subtitle = this.$t('billing.common.form_xx_month', [this.$money(amount)]);
    this.productPlans = this.currentProductPlans;
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    currentProductPlans() {
      return orderBy(
        filter(this.planMapFlat, (p) => p.type === planTypes.ZOOM_ROOMS),
        ['amount'],
        'asc',
      );
    },
    lowestPlan() {
      return get(this.currentProductPlans, [0], {});
    },
  },
};
</script>
